/* ==========================================================================
   Calendar > Vendor > Config
   ========================================================================== */

/* Config base */
const config = {
    init: true,
    minDate: 'today',
    maxDate: new Date().fp_incr(365 * 2),
    dateFormat: 'D, j M Y',
    showMonths: 2,
    locale: {
        rangeSeparator: ' → ',
        firstDayOfWeek: 1 // start week on Monday
    },
    static: true,
    disableMobile: true
};

/* Config base for range mode */
const range = {
    defaultDate: [new Date().fp_incr(7), new Date().fp_incr(9)],
    mode: 'range'
};

/* Config base for single mode */
const single = {
    defaultDate: new Date().fp_incr(7),
    mode: 'single'
};

/* Config base for time mode */
const time = {
    dateFormat: 'D, j M Y H:i',
    defaultDate: new Date().fp_incr(7),
    enableTime: true,
    minuteIncrement: 30,
    mode: 'single',
    noCalendar: false,
    showMonths: 1,
    time_24hr: true
};

/**
 * Arrow function getConfig
 * @param {type} String type of calendar to retrieve the configuration base
 *
 * @return {object} Object containing the configuration base for the calendar
 */
const getConfig = (mode = 'range') => {
    if (mode === 'range') return { ...config, ...range };
    if (mode === 'single') return { ...config, ...single };
    if (mode === 'time') return { ...config, ...time };

    return null;
};

module.exports = getConfig;
